import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import RichMediaInfoTabCard from "../../../../V2/Cards/RichMedia/InfoTab"

import { getUrlFromStoryblokLink } from "@utils/storyblok"

const StoryblokRichMediaInfoTabCar = ({
  blok,
  mobileGridOrder,
  isSliderChild,
}: Storyblok.BlokProps<Storyblok.RichMediaInfoTabCard>) => {
  return (
    <RichMediaInfoTabCard
      mobileGridOrder={mobileGridOrder}
      backgroundVideo={
        blok.backgroundVideoUrl?.url
          ? getUrlFromStoryblokLink(blok.backgroundVideoUrl)
          : ""
      }
      backgroundImage={blok.backgroundImage.filename}
      backgroundImageAlt={blok.backgroundImage.alt}
      accentColor={blok.accentColor}
      superscriptText={blok.superscriptText}
      titleText={blok.titleText}
      descriptionText={blok.descriptionText}
      buttonLink={getUrlFromStoryblokLink(blok.ctaLink)}
      isSliderChild={isSliderChild}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      autoplay={blok.autoplay}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokRichMediaInfoTabCar
